import { Injectable } from '@angular/core';
import { AuthentificationService } from '@app/authentification/authentification.service';

import { HttpApiService } from '@app/providers/http-api/http-api.service';
import { Observable, map, tap } from 'rxjs';
import { AssetDao } from '../asset/asset.dao';
import { Dao } from '../dao';
import { DataLoaderAuthentified } from '../data-loader-authentified';
import { EstateDao } from '../estate/estate.dao';

@Injectable({
  providedIn: 'root',
})
export class TaxesDao extends Dao {
  private taxhouse: DataLoaderAuthentified<any> =
    new DataLoaderAuthentified<any>(this.getAuthentifiedMainUserOrMainUserFromAuthentifiedSpouse(), user => {
      let year = new Date().getFullYear();
      return this.httpApi
        .get(`/user/${user.id}/taxhouse/info/${year}/global`)
        .pipe(map(res => res['data']));
    });

  private tmi: DataLoaderAuthentified<any> = new DataLoaderAuthentified<any>(
    this.getAuthentifiedMainUserOrMainUserFromAuthentifiedSpouse(),
    user => {
      let year = new Date().getFullYear();
      return this.httpApi
        .get(`/user/${user.id}/taxhouse/info/${year}/tmi`)
        .pipe(map(res => res['data']));
    },
  );

  private deductions: DataLoaderAuthentified<any> =
    new DataLoaderAuthentified<any>(this.getAuthentifiedMainUserOrMainUserFromAuthentifiedSpouse(), user => {
      let year = new Date().getFullYear();
      return this.httpApi
        .get(`/user/${user.id}/taxhouse/info/${year}/deduction`)
        .pipe(map(res => res['data']));
    });

  private reductions: DataLoaderAuthentified<any> =
    new DataLoaderAuthentified<any>(this.getAuthentifiedMainUserOrMainUserFromAuthentifiedSpouse(), user => {
      let year = new Date().getFullYear();
      return this.httpApi
        .get(`/user/${user.id}/taxhouse/info/${year}/reduction`)
        .pipe(map(res => res['data']));
    });

  private examptTax: DataLoaderAuthentified<any> =
    new DataLoaderAuthentified<any>(this.getAuthentifiedMainUserOrMainUserFromAuthentifiedSpouse(), (user, current) => {
      return this.httpApi
        .get(
          `/user/${user.id}/assets/defiscalisation/global?current=${current || 'ISCURRENT'}`,
        )
        .pipe(map(res => res['data']));
    });

  constructor(
    httpApi: HttpApiService,
    private estateDao: EstateDao,
    private assetDao: AssetDao,
    authentificationService: AuthentificationService,
  ) {
    super(httpApi, authentificationService);
    this.estateDao.onReset.subscribe(this.reset.bind(this));
    this.assetDao.onReset.subscribe(this.reset.bind(this));
  }

  /* Reference */
  getTaxhouse(): Observable<any> {
    return this.taxhouse.get();
  }
  getTmi(): Observable<any> {
    return this.tmi.get();
  }

  getDeductions(): Observable<any> {
    return this.deductions.get();
  }

  getReductions(): Observable<any> {
    return this.reductions.get();
  }

  getExamptTax(
    current: 'ALL' | 'ISCURRENT' | 'NOTCURRENT' = 'ALL',
  ): Observable<any> {
    return this.examptTax.get(current);
  }

  saveDeductionReduction(
    model: any,
    body: any,
    reset: boolean = true,
    year: any = new Date().getFullYear(),
  ) {
    return this.commandAsMainUser(user =>
      this.httpApi.post(`/user/${user.id}/taxhouse/info/${year}/${model}`, body),
    ).pipe(tap(() => (reset ? this?.reset() : null)));
  }

  deleteDeductionReduction(
    model: any,
    id: any,
    query: string,
    reset: boolean = true,
    year: any = new Date().getFullYear(),
  ) {
    return this.commandAsMainUser(user =>
      this.httpApi.delete(
        `/user/${
          user.id
        }/taxhouse/info/${new Date().getFullYear()}/${model}/${id}?${query}`,
      ),
    ).pipe(tap(() => (reset ? this?.reset() : null)));
  }

  /* state */
  reset() {
    this.taxhouse?.reset();
    this.tmi?.reset();
    this.reductions?.reset();
    this.deductions?.reset();
    this.examptTax?.reset();
  }

  onUserChange(event: any) {
    this?.reset();
  }
}
